import moment from "moment"

// TODO: remove all occurrences because early bird workaround is not needed anymore
export const addLateDeliverySurcharge = (value, lateDelivery) => {
  if (lateDelivery === null || !lateDelivery.hasOwnProperty('surcharge_in_percent')) {
    return value
  }
  
	return value * (1 + (parseFloat(lateDelivery.surcharge_in_percent) / 100))
}

/**
 * 
 * @param {Array} priceLevels 
 * @returns 
 */
export const getActivePriceLevel = (priceLevels) => {
  if (priceLevels.length === 0) {
    return null
  }

  let active = null
  const today = moment()

  for (let i = 0; i < priceLevels.length; i++) {
    const priceLevel = priceLevels[i]
    let date = moment(priceLevel.date)
    
    if (priceLevel.type === 0 && today.isSameOrBefore(date, 'day')) {
      active = priceLevel
      break;
    } else if (priceLevel.type === 1 && today.isSameOrAfter(date, 'day')) {
      active = priceLevel
    }
  }

  return active
}